import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useRef, Fragment } from "react";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import CustomPagination from "../../pagination/Pagination";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import CreateStudent from "./CreateStudent";
import CustomLoader from "../../customLoader/CustomLoader";
import "./Student.css";

const Student = () => {
  const studentInputRef = useRef();
  const timeout = useRef();
  const [user] = useState(
    localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : []
  );
  const [searchInput, setSearchInput] = useState();
  const [page, setPage] = useState(1);
  const [studentListData, setStudentListData] = useState([]);
  const [optionValue, setOptionValue] = useState();
  const [modifyData, setModifyData] = useState({});
  const [modifyStudentIndex, setModifyStudentIndex] = useState();
  const [openCreateMessage, setOpenCreateMessage] = useState(false);
  const [openModifyStudent, setOpenModifyStudent] = useState(false);
  const [loading, setLoading] = useState(false);

  // const getStudentwithId = (value) => {
  //   setLoading(true);
  //   setSearchInput("");
  //   setOptionValue(value);
  //   let obj = {
  //     page: page,
  //     role: "student",
  //     school: user?.school_id,
  //     student_option: value,
  //   };
  //   GetStudentService.getStudent(obj)
  //     .then((data) => {
  //       setStudentListData(data.data);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //     });
  // };

  const getStudentwithId = (value, id = "", newpage = 0) => {
    setLoading(true);
    setSearchInput("");
    let obj = {
      page: page,
      role: "student",
      student: value
    };
    if (newpage === 1) {
      obj.page = 1;
      setPage(1);
    }
    setOptionValue(value);

    if (id) obj.school = id;else
    obj.school = user?.school_id;

    GetStudentService.getStudent(obj)
    .then((data) => {
      setStudentListData(data.data);
      setLoading(false);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const modifyStudent = (item, index) => {
    setModifyStudentIndex(index);
    GetStudentService.modifyStudent(item.id)
    .then((data) => {
      if (!data.data.objects) {
        setModifyData({
          student: {
            first_name: item?.first_name,
            last_name: item?.last_name,
            mobile: item?.mobile,
            email: item?.email,
            id: item?.id
          }
        });
      } else setModifyData(data.data.objects);
      setLoading(false);
    })
    .catch((_error) => {
      setLoading(false);
    });
    setOpenModifyStudent(true);
  };

  const getStudentfromSearchHandler = (value) => {
    let obj = {
      page: page,
      role: "student",
      school: user?.school_id,
      student_option: "",
      q: value
    };
    GetStudentService.getStudent(obj)
    .then((data) => {
      setStudentListData(data.data);
    })
    .catch(() => {});
  };

  useEffect(() => {
    if (user?.school_id) {
      getStudentwithId("all");
    } else
    {
      getStudentwithId(optionValue);
    }
  }, [page]);

  const StudentsHandler = () => {
    clearTimeout(timeout.current);
    setSearchInput(studentInputRef.current.value);
    timeout.current = setTimeout(() => {
      getStudentfromSearchHandler(studentInputRef.current.value);
    }, 500);
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="schoolit-students-page">
            <div className="schoolit-students-header">
              <div>
                <h1 className="schoolit-students-title">Students</h1>
                <p className="schoolit-students-subtitle">
                  Search, filter, and manage students for your school
                </p>
              </div>
              <button
                type="button"
                onClick={() => setOpenCreateMessage(true)}
                className="schoolit-students-btn">

                <FontAwesomeIcon icon={faUsers} />
                New Students
              </button>
            </div>

            <div className="schoolit-students-card">
              <div className="schoolit-students-field">
                <label className="schoolit-students-label">School</label>
                <div className="schoolit-students-school">
                  {user?.school_name}
                </div>
              </div>

              <div className="schoolit-students-field">
                <label className="schoolit-students-label" htmlFor="student-search">
                  Search
                </label>
                <input
                  id="student-search"
                  type="text"
                  ref={studentInputRef}
                  className="schoolit-students-search"
                  placeholder="Search Students"
                  onChange={StudentsHandler}
                  value={searchInput || ""} />

              </div>

              <div className="schoolit-students-toolbar">
                <p className="schoolit-students-section-title">Students</p>
                <div className="schoolit-students-filters">
                  <span className="schoolit-students-filter-label">Show:</span>
                  <div className="schoolit-students-filter-group">
                    <button
                      type="button"
                      onClick={() => getStudentwithId("all")}
                      className={`schoolit-students-filter-btn ${
                      optionValue === "all" ? "is-active" : ""
                      }`}>

                      All
                    </button>
                    <button
                      type="button"
                      onClick={() => getStudentwithId("with_id")}
                      className={`schoolit-students-filter-btn ${
                      optionValue === "with_id" ? "is-active" : ""
                      }`}>

                      with ID
                    </button>
                    <button
                      type="button"
                      onClick={() => getStudentwithId("without_id")}
                      className={`schoolit-students-filter-btn ${
                      optionValue === "without_id" ? "is-active" : ""
                      }`}>

                      without ID
                    </button>
                  </div>
                </div>
              </div>

              {loading ?
              <CustomLoader /> :
              studentListData?.result?.length > 0 ?
              <div className="schoolit-students-list">
                  {studentListData.result.map((item, index) =>
                <div
                  key={item?.id || index}
                  className={`schoolit-students-item ${
                  index === modifyStudentIndex ? "is-active" : ""
                  }`}
                  onClick={() => modifyStudent(item, index)}>

                      <p className="schoolit-students-name">
                        {`${item.last_name}, ${item.first_name}`}
                      </p>
                      <p className="schoolit-students-email">{`<${item.email}>`}</p>
                    </div>
                )}
                </div> :

              <div className="schoolit-students-empty">No students found</div>}


              {studentListData &&
              <div className="schoolit-students-pagination">
                  <CustomPagination
                  count={studentListData}
                  pageValue={page}
                  setPage={setPage} />

                </div>}

            </div>

            {openCreateMessage &&
            <CreateStudent
              setOpenCreateMessage={setOpenCreateMessage}
              modify={false}
              getStudentwithId={getStudentwithId}
              setOpenCreateStudent={setOpenModifyStudent} />}


            {openModifyStudent &&
            <CreateStudent
              setOpenCreateMessage={setOpenModifyStudent}
              modify={modifyData}
              getStudentwithId={getStudentwithId}
              setOpenCreateStudent={setOpenModifyStudent} />}


          </div>
        </div>
      </div>
    </Fragment>);

};

export default Student;